import { useContext, createContext } from 'react';
import { PageProps } from './magnolia';
export const GlobalMGLPropsContext = createContext<PageProps | undefined>(undefined);
export const useGlobalMGLProps = (): PageProps | undefined => {
  return useContext(GlobalMGLPropsContext);
};
